import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Archive Design Studio was a website to showcase and advertise floor plans and feasibility studies produced by an architecture studio.`}</p>
    <p>{`The site is built in HTML5, uses PHP for reusable file includes and LESS for styling (which is compiled down to CSS). The main functionality is in the Projects section. This shows the floorplans of each house in a preselected layout, which is loaded in from a JSON file. This is written using AngularJS.`}</p>
    <p>{`Unfortunately, the website is no longer live.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      